import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import './App.css';
import About from "./components/About";
import Download from "./components/Download";
import Home from './components/Home';
import PrivacyPolicy from "./components/PrivacyPolicy";
import SiteSwitcher from "./components/SiteSwitcher";
import Support from "./components/Support";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/:siteid/pages/about" render={(props) => <About {...props} />} />
        <Route path="/:siteid/pages/download" render={(props) => <Download {...props} />} />
        <Route path="/:siteid/pages/privacy-policy.html" render={(props) => <PrivacyPolicy {...props} />} />
        <Route path="/:siteid/pages/support.html" render={(props) => <Support {...props} />} />
        <Route path="/:siteid/" render={(props) => <Home {...props} />} />
        <Route path="/" render={(props) => <SiteSwitcher {...props} />} />
      </Switch>
    </Router>
  );
}

export default App;
